import { useQuery } from '@tanstack/react-query'

import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { usePermissions } from '../../auth/hooks/usePermissions'
import { ProjectSource } from '../../auth/lib/auth.types'
import { useSelectedProject } from '../../main/hooks/useSelectedProject'
import { FinanceService } from '../lib/finance.service'

const FINANCE_BALANCES_QUERY_KEY = 'balances'

type Props = {
  personalAccountId?: string
  alias?: string
  enabled?: boolean
}

export const useBalances = ({
  personalAccountId,
  alias,
  enabled = true
}: Props) => {
  const { selectedProjectId } = useSelectedProjectStore()
  const { selectedProject } = useSelectedProject()
  const permissions = usePermissions()

  const { data, isLoading, error, isError, refetch } = useQuery({
    queryKey: [
      FINANCE_BALANCES_QUERY_KEY,
      selectedProjectId,
      personalAccountId,
      alias
    ],
    queryFn: () =>
      FinanceService.getBalances({
        projectId: selectedProjectId,
        personalAccountId
      }),
    enabled:
      enabled &&
      Boolean(selectedProjectId) &&
      selectedProject?.src === ProjectSource.SC &&
      permissions.finances
  })

  return { data, isLoading, error, isError, refetch }
}
